$(document).ready(function () {

    // Add function to add a class to the navbar when scrolled
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > 46) {
            $('.navbar').addClass('scrolled');
        } else {
            $('.navbar').removeClass('scrolled');
        }
    });

    $("nav.navbar #navMenuExample .menu-item-has-children .navbar-dropdown").hover(function () {
        $(this).closest('.has-dropdown').find('.menu-item-has-children').css("color", "#fff");
    }, function () {
        $(this).closest('.has-dropdown').find('.menu-item-has-children').css("color", "#193C6C");
        $(this).css("color", "#fff");
    });

    $("div.slideout .label").click(function () {
        $(this).parent('.slideout').toggleClass("active");
    });

    $("nav.navbar #navMenuExample .menu-item.has-dropdown span.toggledropdown").click(function () {
        $(this).siblings('.navbar-dropdown').slideToggle();
        $(this).find('i').toggleClass('rotated');
    });

    // $('section.home-events .column .content-wrap .text .title').matchHeight();
    // $('section.home-discussionpapers .column .content-wrap .text .title').matchHeight();

    // $('section.home-blogs .images').slick({
    //     fade: true,
    //     speed: 1000,
    //     cssEase: 'linear',
    //     arrows: false,
    //     dots: false,
    //     autoplay: true,
    // });

    // $('section.contact .slides .slider-wrap').slick({
    //     speed: 1000,
    //     cssEase: 'linear',
    //     arrows: false,
    //     dots: true,
    //     autoplay: true,
    // });

    // $("section.inpage-nav .topbar .arrow").click(function () {
    //     $(this).toggleClass('rotated');
    //     $("section.inpage-nav .navigation").slideToggle();
    // });

    // $.fn.isInViewport = function () {
    //     var elementTop = $(this).offset().top;
    //     var elementBottom = elementTop + $(this).outerHeight() / 2;
    //     var viewportTop = $(window).scrollTop();
    //     var viewportHalf = viewportTop + $(window).height() / 1.2;
    //
    //     return elementBottom > viewportTop && elementTop < viewportHalf;
    // };

    // $(window).on('load resize scroll', function () {
    //     $('.effect').each(function () {
    //         if ($(this).isInViewport()) {
    //             $(this).addClass('fade-in');
    //         } /* else {
    //             $(this).removeClass('fade-in');
    //         } */
    //     });
    //
    //     $('.to-slide-out').each(function () {
    //         if ($(this).isInViewport()) {
    //             $(this).addClass('slideout');
    //         } /* else {
    //             $(this).removeClass('fade-in');
    //         } */
    //     });
    // });
});

// function sticky_relocate() {
//     if ($('#sticky-anchor').length) {
//         var window_top = $(window).scrollTop();
//         var div_top = $('#sticky-anchor').offset().top - 90;
//         if (window_top > div_top) {
//             $('.inpage-nav').addClass('stick');
//             $('section.inpage-nav .topbar .arrow').addClass('rotated');
//             $("section.inpage-nav .navigation").slideUp();
//         } else {
//             $('.inpage-nav').removeClass('stick');
//         }
//     }
// }

// $(function () {
//     $(window).scroll(sticky_relocate);
//     sticky_relocate();
// });

//Below is standard Bulma code to load the hamburger menu
document.addEventListener('DOMContentLoaded', function () {

    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any nav burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(function ($el) {
            $el.addEventListener('click', function () {

                // Get the target from the "data-target" attribute
                var target = $el.dataset.target;
                var $target = document.getElementById(target);

                // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                $el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
            });
        });
    }

    // Functions to open and close a modal
    function openModal($el) {
        $el.classList.add('is-active');
    }

    function closeModal($el) {
        $el.classList.remove('is-active');
    }

    function closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(($modal) => {
            closeModal($modal);
        });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.login-modal-trigger') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        $trigger.addEventListener('click', () => {
            openModal($target);
        });
    });

    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
        const $target = $close.closest('.modal');

        $close.addEventListener('click', () => {
            closeModal($target);
        });
    });

    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event) => {
        if (event.key === "Escape") {
            closeAllModals();
        }
    });
});